import ContentComponent from './ContentComponent/ContentComponent'
import HeadingComponent from './HeadingComponent/HeadingComponent'
import KickerComponent from './KickerComponent/KickerComponent'
import TitleComponent from './TitleComponent/TitleComponent'

export const Kicker = KickerComponent
export const Heading = HeadingComponent
export const Content = ContentComponent
export const Title = TitleComponent
